import * as actionTypes from "../../actions/actionTypes";
import {updateObject} from "../../shared/utility";

const initialState = {
  startNewList: false,
  listLoading: false,
  message: '',
  msgType: '',
  totalLists: 0,
  participantLists: [],
  // List Detail Data
  startAddParticipants: false,
  listDetailPage: 0,
  totalListParticipants: 0,
  listParticipants: [],
};

const reducer = (state = initialState, action: any) => {
  switch (action.type) {
    case actionTypes.SET_PARTICIPANT_LIST_LOADING:
      return updateObject(state, {
        listLoading: action.payload
      });

    case actionTypes.UPDATE_PARTICIPANT_LIST_MSG:
      return updateObject(state, {
        message: action.payload['message'],
        msgType: action.payload['msgType']
      });

    case actionTypes.INIT_PARTICIPANT_LIST_MSG:
      return updateObject(state, {
        message: '',
        msgType: ''
      });

    case actionTypes.INIT_PARTICIPANT_LIST_DATA:
      return updateObject(state, {
        totalLists: 0,
        participantLists: []
      });

    case actionTypes.INIT_LIST_DETAIL_DATA:
      return updateObject(state, {
        listDetailPage: 0,
        totalListParticipants: 0,
        listParticipants: []
      });

    case actionTypes.UPDATE_LIST_DETAIL_PAGE:
      return updateObject(state, {
        listDetailPage: action.payload
      });

    case actionTypes.START_PARTICIPANT_LIST_CREATE:
      return updateObject(state, {
        startNewList: action.payload
      });

    case actionTypes.START_ADD_PARTICIPANTS:
      return updateObject(state, {
        startAddParticipants: action.payload
      });

    case actionTypes.UPDATE_PARTICIPANT_LISTS:
      const totalLists = action.payload ? action.payload['total'] : 0;
      const lists = action.payload ? action.payload['participants_group'] : [];
      const sortedArr = lists.reduce((acc: any[], element: any) => {
        if (element.group_name
          && (element.group_name === 'All-time Invited' || element.group_name === 'All-time Completed')
        ) {
          return [element, ...acc];
        }
        return [...acc, element];
      }, []);
      return updateObject(state, {
        totalLists: totalLists,
        participantLists: sortedArr
      });

    case actionTypes.UPDATE_LIST_PARTICIPANTS:
      const totalParticipants = action.payload ? action.payload['total'] : 0;
      const participants = action.payload ? action.payload['participants_group_list'] : [];
      const newParticipants = state.listParticipants.concat(participants);
      return updateObject(state, {
        totalListParticipants: totalParticipants,
        listParticipants: newParticipants
      });

    default:
      return state;
  }
};

export default reducer;